module.exports = __webpack_public_path__ + "img/arrow-back.5b6d3648.svg";